export const ADMIN = "XXjtDgchUAdrt7tNIhxjrfytRun1"